import React, { FormEvent, useEffect, useState } from "react";
import "../../../styles/desktopVersion/arrangeDelivery.css";
import { DataGrid, GridFooterContainer } from "@mui/x-data-grid";
import {
  Autocomplete,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Pagination,
  Select,
  TextField,
} from "@mui/material";
import { DeliveryService } from "../../../services/DeliveryService";
import { UserService } from "../../../services/UserService";
import { PaymentService } from "../../../services/PaymentService";
import { OrderService } from "../../../services/OrderService";
import { useTranslation } from "react-i18next";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import { checkModalResponse } from "../../../helpers/helpers";

const modalInitialValues = {
  open: false,
  values: {
    id: "",
    sorting_group: "",
    address: "",
    phone: "",
    payment: "",
  },
  validation: {
    error: {
      address: false,
      phone: false,
      payment: false,
    },
    message: {
      address: "",
      phone: "",
      payment: "",
    },
  },
  requested: false,
};

const tableInitialValues = {
  rows: [],
  filter: {
    delivery_country: "",
    search: "",
    page: 1,
    total_pages: 1,
    updateTable: false,
  },
  status: {
    loading: false,
    error: false,
    message: "",
  },
  selectedRows: [],
};

export default function DeliveryAdd() {
  //translation
  const { t } = useTranslation();

  const addresses = UserService.GetUserAddresses();
  const phones = UserService.GetUserPhones();
  const payments = PaymentService.GetPayments();

  const [table, setTable] = useState<any>({
    ...tableInitialValues,
    columns: [
      { field: "id", headerName: "ID посылки", flex: 1, hide: true },
      {
        field: "user_id",
        headerName: "Код клиента",
        flex: 1,
        renderCell: (params: any) => params.row.customer?.id,
      },
      { field: "full_name", headerName: "ФИО", flex: 1 },
      {
        field: "customer_country",
        headerName: "Страна клиента",
        flex: 1,
        renderCell: (params: any) =>
          params.row.customer?.user?.country?.country,
      },
      { field: "orders_count", headerName: "Количество", flex: 1 },
      { field: "total_weight", headerName: "Вес", flex: 1 },
      {
        field: "actions",
        headerName: `Действия`,
        width: 100,
        sortable: false,
        renderCell: (params: any) => (
          <IconButton
            title="оформить доставку"
            onClick={() => {
              setModal({
                ...modal,
                open: true,
                values: {
                  ...modal.values,
                  id: params.row.id,
                  sorting_group: params.row.id,
                },
              });
            }}
          >
            <LocalShippingIcon />
          </IconButton>
        ),
      },
    ],
  });
  const tableList = OrderService.GetOrdersForDelivery(table.filter);

  const [modal, setModal] = useState(modalInitialValues);
  const handleFormSubmit = (e: FormEvent) => {
    e.preventDefault();
    setModal({
      ...modal,
      requested: true,
    });
    DeliveryService.CreateDelivery(modal.values)
      .then(() => {
        tableList.execute();
        setModal(modalInitialValues);
      })
      .catch((err) => {
        checkModalResponse(err.response.data, setModal, modal);
      });
  };

  useEffect(() => {
    if (tableList.loading) {
      setTable((prevState: any) => ({
        ...prevState,
        status: {
          ...prevState.status,
          loading: true,
        },
      }));
    } else if (tableList.error) {
      setTable((prevState: any) => ({
        ...prevState,
        status: {
          ...prevState.status,
          loading: false,
          error: true,
        },
      }));
    } else {
      const data = tableList.result?.data;
      setTable((prevState: any) => ({
        ...prevState,
        rows: data.results,
        status: {
          ...prevState.status,
          loading: false,
          error: false,
        },
        filter: {
          ...prevState.filter,
          page: data.current_page,
          total_pages: data.total_pages,
        },
      }));
    }
  }, [tableList.loading, tableList.error, tableList.result?.data]);
  useEffect(() => {
    const isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
      input !== null && input.tagName === "IFRAME";

    let frame = document.getElementById("map_376303947");
    if (isIFrame(frame) && frame.contentWindow) {
      frame.contentWindow.document.open();

      frame.contentWindow.document.write(
        atob(
          "PGJvZHk+PHN0eWxlPgogICAgICAgIGh0bWwsIGJvZHkgewogICAgICAgICAgICBtYXJnaW46IDA7CiAgICAgICAgICAgIHBhZGRpbmc6IDA7CiAgICAgICAgfQogICAgICAgIGh0bWwsIGJvZHksICNtYXAgewogICAgICAgICAgICB3aWR0aDogMTAwJTsKICAgICAgICAgICAgaGVpZ2h0OiAxMDAlOwogICAgICAgIH0KICAgICAgICAuYnVsbGV0LW1hcmtlciB7CiAgICAgICAgICAgIHdpZHRoOiAyMHB4OwogICAgICAgICAgICBoZWlnaHQ6IDIwcHg7CiAgICAgICAgICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7CiAgICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6ICNmZmY7CiAgICAgICAgICAgIGJveC1zaGFkb3c6IDAgMXB4IDNweCAwIHJnYmEoMCwgMCwgMCwgMC4yKTsKICAgICAgICAgICAgYm9yZGVyOiA0cHggc29saWQgIzAyODFmMjsKICAgICAgICAgICAgYm9yZGVyLXJhZGl1czogNTAlOwogICAgICAgIH0KICAgICAgICAucGVybWFuZW50LXRvb2x0aXAgewogICAgICAgICAgICBiYWNrZ3JvdW5kOiBub25lOwogICAgICAgICAgICBib3gtc2hhZG93OiBub25lOwogICAgICAgICAgICBib3JkZXI6IG5vbmU7CiAgICAgICAgICAgIHBhZGRpbmc6IDZweCAxMnB4OwogICAgICAgICAgICBjb2xvcjogIzI2MjYyNjsKICAgICAgICB9CiAgICAgICAgLnBlcm1hbmVudC10b29sdGlwOmJlZm9yZSB7CiAgICAgICAgICAgIGRpc3BsYXk6IG5vbmU7CiAgICAgICAgfQogICAgICAgIC5kZy1wb3B1cF9oaWRkZW5fdHJ1ZSB7CiAgICAgICAgICAgIGRpc3BsYXk6IGJsb2NrOwogICAgICAgIH0KICAgICAgICAubGVhZmxldC1jb250YWluZXIgLmxlYWZsZXQtcG9wdXAgLmxlYWZsZXQtcG9wdXAtY2xvc2UtYnV0dG9uIHsKICAgICAgICAgICAgdG9wOiAwOwogICAgICAgICAgICByaWdodDogMDsKICAgICAgICAgICAgd2lkdGg6IDIwcHg7CiAgICAgICAgICAgIGhlaWdodDogMjBweDsKICAgICAgICAgICAgZm9udC1zaXplOiAyMHB4OwogICAgICAgICAgICBsaW5lLWhlaWdodDogMTsKICAgICAgICB9CiAgICA8L3N0eWxlPjxkaXYgaWQ9Im1hcCI+PC9kaXY+PHNjcmlwdCB0eXBlPSJ0ZXh0L2phdmFzY3JpcHQiIHNyYz0iaHR0cHM6Ly9tYXBzLmFwaS4yZ2lzLnJ1LzIuMC9sb2FkZXIuanM/cGtnPWZ1bGwmYW1wO3NraW49bGlnaHQiPjwvc2NyaXB0PjxzY3JpcHQ+KGZ1bmN0aW9uKGUpe3ZhciB0PUpTT04ucGFyc2UoZSkscj10Lm9yZGVyZWRHZW9tZXRyaWVzLG49dC5tYXBQb3NpdGlvbixhPXQuaXNXaGVlbFpvb21FbmFibGVkO2Z1bmN0aW9uIG8oZSl7cmV0dXJuIGRlY29kZVVSSUNvbXBvbmVudChhdG9iKGUpLnNwbGl0KCIiKS5tYXAoZnVuY3Rpb24oZSl7cmV0dXJuIiUiKygiMDAiK2UuY2hhckNvZGVBdCgwKS50b1N0cmluZygxNikpLnNsaWNlKC0yKX0pLmpvaW4oIiIpKX1ERy50aGVuKGZ1bmN0aW9uKCl7dmFyIGU9REcubWFwKCJtYXAiLHtjZW50ZXI6W24ubGF0LG4ubG9uXSx6b29tOm4uem9vbSxzY3JvbGxXaGVlbFpvb206YSx6b29tQ29udHJvbDohYX0pO0RHLmdlb0pTT04ocix7c3R5bGU6ZnVuY3Rpb24oZSl7dmFyIHQscixuLGEsbztyZXR1cm57ZmlsbENvbG9yOm51bGw9PT0odD1lKXx8dm9pZCAwPT09dD92b2lkIDA6dC5wcm9wZXJ0aWVzLmZpbGxDb2xvcixmaWxsT3BhY2l0eTpudWxsPT09KHI9ZSl8fHZvaWQgMD09PXI/dm9pZCAwOnIucHJvcGVydGllcy5maWxsT3BhY2l0eSxjb2xvcjpudWxsPT09KG49ZSl8fHZvaWQgMD09PW4/dm9pZCAwOm4ucHJvcGVydGllcy5zdHJva2VDb2xvcix3ZWlnaHQ6bnVsbD09PShhPWUpfHx2b2lkIDA9PT1hP3ZvaWQgMDphLnByb3BlcnRpZXMuc3Ryb2tlV2lkdGgsb3BhY2l0eTpudWxsPT09KG89ZSl8fHZvaWQgMD09PW8/dm9pZCAwOm8ucHJvcGVydGllcy5zdHJva2VPcGFjaXR5fX0scG9pbnRUb0xheWVyOmZ1bmN0aW9uKGUsdCl7cmV0dXJuInJhZGl1cyJpbiBlLnByb3BlcnRpZXM/REcuY2lyY2xlKHQsZS5wcm9wZXJ0aWVzLnJhZGl1cyk6REcubWFya2VyKHQse2ljb246ZnVuY3Rpb24oZSl7cmV0dXJuIERHLmRpdkljb24oe2h0bWw6IjxkaXYgY2xhc3M9J2J1bGxldC1tYXJrZXInIHN0eWxlPSdib3JkZXItY29sb3I6ICIrZSsiOyc+PC9kaXY+IixjbGFzc05hbWU6Im92ZXJyaWRlLWRlZmF1bHQiLGljb25TaXplOlsyMCwyMF0saWNvbkFuY2hvcjpbMTAsMTBdfSl9KGUucHJvcGVydGllcy5jb2xvcil9KX0sb25FYWNoRmVhdHVyZTpmdW5jdGlvbihlLHQpe2UucHJvcGVydGllcy5kZXNjcmlwdGlvbiYmdC5iaW5kUG9wdXAobyhlLnByb3BlcnRpZXMuZGVzY3JpcHRpb24pLHtjbG9zZUJ1dHRvbjohMCxjbG9zZU9uRXNjYXBlS2V5OiEwfSksZS5wcm9wZXJ0aWVzLnRpdGxlJiZ0LmJpbmRUb29sdGlwKG8oZS5wcm9wZXJ0aWVzLnRpdGxlKSx7cGVybWFuZW50OiEwLG9wYWNpdHk6MSxjbGFzc05hbWU6InBlcm1hbmVudC10b29sdGlwIn0pfX0pLmFkZFRvKGUpfSl9KSgneyJvcmRlcmVkR2VvbWV0cmllcyI6W3sidHlwZSI6IkZlYXR1cmUiLCJwcm9wZXJ0aWVzIjp7ImRlc2NyaXB0aW9uIjoiIiwic3Ryb2tlQ29sb3IiOiIjMDAwZmZmIiwic3Ryb2tlV2lkdGgiOjMsInN0cm9rZU9wYWNpdHkiOjEsInpJbmRleCI6MX0sImdlb21ldHJ5Ijp7InR5cGUiOiJMaW5lU3RyaW5nIiwiY29vcmRpbmF0ZXMiOltbNzQuNTg4NDU1LDQyLjgwMzU1Nl0sWzc0LjU4NDI5Myw0Mi44MDMwODRdLFs3NC41ODE5MzMsNDIuODAzODRdLFs3NC41Njk0NDcsNDIuODA0ODc5XV19LCJpZCI6MTg1Nn0seyJ0eXBlIjoiRmVhdHVyZSIsInByb3BlcnRpZXMiOnsiZGVzY3JpcHRpb24iOiIiLCJzdHJva2VDb2xvciI6IiMwMDBmZmYiLCJzdHJva2VXaWR0aCI6Mywic3Ryb2tlT3BhY2l0eSI6MSwiekluZGV4IjoyfSwiZ2VvbWV0cnkiOnsidHlwZSI6IkxpbmVTdHJpbmciLCJjb29yZGluYXRlcyI6W1s3NC41NjkzNjEsNDIuODA0ODc5XSxbNzQuNTY1OCw0Mi44MDU2MzRdLFs3NC41NjE4NTIsNDIuODA1NzI5XSxbNzQuNTU4MjQ4LDQyLjgwNTQ0NV0sWzc0LjU1NjYxNyw0Mi44MDU0NDVdLFs3NC41NTQyNTcsNDIuODEwNTE0XSxbNzQuNTUzMjY2LDQyLjgxMTY0OF0sWzc0LjU1MjI4NCw0Mi44MTI3ODFdLFs3NC41NTAzOTYsNDIuODE1NzcyXSxbNzQuNTUwMDk1LDQyLjgxNjg0Ml1dfSwiaWQiOjE5ODh9LHsidHlwZSI6IkZlYXR1cmUiLCJwcm9wZXJ0aWVzIjp7ImRlc2NyaXB0aW9uIjoiIiwic3Ryb2tlQ29sb3IiOiIjMDAwZmZmIiwic3Ryb2tlV2lkdGgiOjMsInN0cm9rZU9wYWNpdHkiOjEsInpJbmRleCI6M30sImdlb21ldHJ5Ijp7InR5cGUiOiJMaW5lU3RyaW5nIiwiY29vcmRpbmF0ZXMiOltbNzQuNTUwMDk1LDQyLjgxNjg0Ml0sWzc0LjU0NDczMiw0Mi44MjU1OTNdLFs3NC41NDI5Myw0Mi44Mjk3MTZdXX0sImlkIjoyMTA3fSx7InR5cGUiOiJGZWF0dXJlIiwicHJvcGVydGllcyI6eyJkZXNjcmlwdGlvbiI6IiIsInN0cm9rZUNvbG9yIjoiIzAwMGZmZiIsInN0cm9rZVdpZHRoIjozLCJzdHJva2VPcGFjaXR5IjoxLCJ6SW5kZXgiOjR9LCJnZW9tZXRyeSI6eyJ0eXBlIjoiTGluZVN0cmluZyIsImNvb3JkaW5hdGVzIjpbWzc0LjU0Mjg1LDQyLjgyOTcxNl0sWzc0LjU0MzM2NSw0Mi44NDQxMjldLFs3NC41MzUzNzgsNDIuODQ0MzE4XSxbNzQuNTM1NDIxLDQyLjg1MTk5NV1dfSwiaWQiOjI2MDl9LHsidHlwZSI6IkZlYXR1cmUiLCJwcm9wZXJ0aWVzIjp7ImRlc2NyaXB0aW9uIjoiIiwic3Ryb2tlQ29sb3IiOiIjMDAwZmZmIiwic3Ryb2tlV2lkdGgiOjMsInN0cm9rZU9wYWNpdHkiOjEsInpJbmRleCI6NX0sImdlb21ldHJ5Ijp7InR5cGUiOiJMaW5lU3RyaW5nIiwiY29vcmRpbmF0ZXMiOltbNzQuNTM1NTUsNDIuODUxOTYzXSxbNzQuNTM2NDUxLDQyLjg2MDMzMl0sWzc0LjUzNjMyMiw0Mi44NjQyNjRdLFs3NC41MzU3NjQsNDIuODY0MTY5XSxbNzQuNTM0NjkxLDQyLjg2NDcwNF0sWzc0LjUyNTQzMSw0Mi44NjM4ODZdXX0sImlkIjozMDA5fSx7InR5cGUiOiJGZWF0dXJlIiwicHJvcGVydGllcyI6eyJkZXNjcmlwdGlvbiI6IiIsInN0cm9rZUNvbG9yIjoiIzAwMGZmZiIsInN0cm9rZVdpZHRoIjozLCJzdHJva2VPcGFjaXR5IjoxLCJ6SW5kZXgiOjZ9LCJnZW9tZXRyeSI6eyJ0eXBlIjoiTGluZVN0cmluZyIsImNvb3JkaW5hdGVzIjpbWzc0LjUyNTUxNyw0Mi44NjM3Nl0sWzc0LjUyMzM3Miw0Mi44NzQyMDNdLFs3NC41MjIxNyw0Mi44NzQyNjZdLFs3NC41MjA2MjYsNDIuODg0ODk1XSxbNzQuNTU0NTIzLDQyLjg4NDcwNl0sWzc0LjU1NTg5Niw0Mi44ODQwMTVdLFs3NC41NTk4NDMsNDIuODgzODg5XSxbNzQuNTY5MTExLDQyLjg4NTAyMV0sWzc0LjU3NjMyLDQyLjg4NDcwNl1dfSwiaWQiOjMxNDF9LHsidHlwZSI6IkZlYXR1cmUiLCJwcm9wZXJ0aWVzIjp7ImRlc2NyaXB0aW9uIjoiIiwic3Ryb2tlQ29sb3IiOiIjMDAwZmZmIiwic3Ryb2tlV2lkdGgiOjMsInN0cm9rZU9wYWNpdHkiOjEsInpJbmRleCI6N30sImdlb21ldHJ5Ijp7InR5cGUiOiJMaW5lU3RyaW5nIiwiY29vcmRpbmF0ZXMiOltbNzQuNTc2MzAzLDQyLjg4NDY0NF0sWzc0LjU3NDYyOSw0Mi44OTU4MDZdXX0sImlkIjo0MDA1fSx7InR5cGUiOiJGZWF0dXJlIiwicHJvcGVydGllcyI6eyJkZXNjcmlwdGlvbiI6IiIsInN0cm9rZUNvbG9yIjoiIzAwMGZmZiIsInN0cm9rZVdpZHRoIjozLCJzdHJva2VPcGFjaXR5IjoxLCJ6SW5kZXgiOjh9LCJnZW9tZXRyeSI6eyJ0eXBlIjoiTGluZVN0cmluZyIsImNvb3JkaW5hdGVzIjpbWzc0LjU3NDYyOSw0Mi44OTU4MDZdLFs3NC41NzQwMjgsNDIuODk5OTg3XSxbNzQuNTczNzI4LDQyLjkwMjI1XSxbNzQuNTczNzcxLDQyLjkwNTQ4OF0sWzc0LjU5MDM3OSw0Mi45MDU1Ml0sWzc0LjU5MzI1NCw0Mi45MDMxNjJdLFs3NC42MDQ4ODQsNDIuOTAzMjU2XV19LCJpZCI6NDA1M30seyJ0eXBlIjoiRmVhdHVyZSIsInByb3BlcnRpZXMiOnsiZGVzY3JpcHRpb24iOiIiLCJzdHJva2VDb2xvciI6IiMwMDBmZmYiLCJzdHJva2VXaWR0aCI6Mywic3Ryb2tlT3BhY2l0eSI6MSwiekluZGV4Ijo5fSwiZ2VvbWV0cnkiOnsidHlwZSI6IkxpbmVTdHJpbmciLCJjb29yZGluYXRlcyI6W1s3NC42MDQ4NDEsNDIuOTAzMTkzXSxbNzQuNjEyMzUxLDQyLjkwMzYzNF0sWzc0LjYxMTQ5Myw0Mi44OTU5XSxbNzQuNjE2OTg2LDQyLjg5NDg2Ml0sWzc0LjYyNTYxMiw0Mi44OTMzNTNdLFs3NC42MjcyNDMsNDIuODkzODg4XSxbNzQuNjI4OTYsNDIuODk0ODYyXSxbNzQuNjI5OTA0LDQyLjg5NDg2Ml0sWzc0LjYzMTQwNiw0Mi44OTQ2MTFdLFs3NC42MzM4OTUsNDIuODk0MzI4XV19LCJpZCI6NDE1M30seyJ0eXBlIjoiRmVhdHVyZSIsInByb3BlcnRpZXMiOnsiZGVzY3JpcHRpb24iOiIiLCJzdHJva2VDb2xvciI6IiMwMDBmZmYiLCJzdHJva2VXaWR0aCI6Mywic3Ryb2tlT3BhY2l0eSI6MSwiekluZGV4IjoxMH0sImdlb21ldHJ5Ijp7InR5cGUiOiJMaW5lU3RyaW5nIiwiY29vcmRpbmF0ZXMiOltbNzQuNjMzOTgxLDQyLjg5NDM1OV0sWzc0LjYzNzE1Niw0Mi44OTQ0ODVdLFs3NC42MzgxMDEsNDIuODk0MzkxXSxbNzQuNjQzMTIyLDQyLjg5MjMxNl0sWzc0LjY0NDQ5NSw0Mi44OTIyMjFdLFs3NC42NDY4NTUsNDIuODkzMTAyXSxbNzQuNjQ4NDQzLDQyLjg5MzM1M10sWzc0LjY1MDU0Niw0Mi44OTI5NDVdLFs3NC42NTE5MTksNDIuODkyMDk2XSxbNzQuNjUzNTUsNDIuODkxNTNdLFs3NC42NTY0NjgsNDIuODkxNjg3XSxbNzQuNjYwNDYsNDIuODkxOTddLFs3NC42Njg2OTksNDIuODkwNDI5XSxbNzQuNjc3NTQsNDIuODg5MTRdLFs3NC42Nzg4Nyw0Mi44ODc3NTddXX0sImlkIjo0NDE3fSx7InR5cGUiOiJGZWF0dXJlIiwicHJvcGVydGllcyI6eyJkZXNjcmlwdGlvbiI6IiIsInN0cm9rZUNvbG9yIjoiIzAwMGZmZiIsInN0cm9rZVdpZHRoIjozLCJzdHJva2VPcGFjaXR5IjoxLCJ6SW5kZXgiOjExfSwiZ2VvbWV0cnkiOnsidHlwZSI6IkxpbmVTdHJpbmciLCJjb29yZGluYXRlcyI6W1s3NC42Nzg4MjcsNDIuODg3Njk0XSxbNzQuNjc4NTI3LDQyLjg4NTcxM10sWzc0LjY5MjI2LDQyLjg4MjY2Ml0sWzc0LjY5MTQ4Nyw0Mi44Nzk0ODZdLFs3NC42OTA1NDMsNDIuODc3NzI1XV19LCJpZCI6NDYyNX0seyJ0eXBlIjoiRmVhdHVyZSIsInByb3BlcnRpZXMiOnsiZGVzY3JpcHRpb24iOiIiLCJzdHJva2VDb2xvciI6IiMwMDBmZmYiLCJzdHJva2VXaWR0aCI6Mywic3Ryb2tlT3BhY2l0eSI6MSwiekluZGV4IjoxMn0sImdlb21ldHJ5Ijp7InR5cGUiOiJMaW5lU3RyaW5nIiwiY29vcmRpbmF0ZXMiOltbNzQuNjkwNDU3LDQyLjg3NzY5NF0sWzc0LjY5MDU4Niw0Mi44NjddLFs3NC42OTE5OTQsNDIuODU1MTQxXV19LCJpZCI6NDcwM30seyJ0eXBlIjoiRmVhdHVyZSIsInByb3BlcnRpZXMiOnsiZGVzY3JpcHRpb24iOiIiLCJzdHJva2VDb2xvciI6IiMwMDBmZmYiLCJzdHJva2VXaWR0aCI6Mywic3Ryb2tlT3BhY2l0eSI6MSwiekluZGV4IjoxM30sImdlb21ldHJ5Ijp7InR5cGUiOiJMaW5lU3RyaW5nIiwiY29vcmRpbmF0ZXMiOltbNzQuNjkxOTk0LDQyLjg1NTA3OF0sWzc0LjY3NTQyOCw0Mi44NTU4MzNdLFs3NC42NjYzMyw0Mi44NTYwODVdLFs3NC42NjQzNTYsNDIuODU0ODI2XSxbNzQuNjQ5OTM3LDQyLjg1NTMzXSxbNzQuNjUwMDIzLDQyLjg0MTM2XSxbNzQuNjM2NTQ3LDQyLjg0MTczN10sWzc0LjYzODk1LDQyLjgzNDQzN11dfSwiaWQiOjQ5MDN9LHsidHlwZSI6IkZlYXR1cmUiLCJwcm9wZXJ0aWVzIjp7ImRlc2NyaXB0aW9uIjoiIiwic3Ryb2tlQ29sb3IiOiIjMDAwZmZmIiwic3Ryb2tlV2lkdGgiOjMsInN0cm9rZU9wYWNpdHkiOjEsInpJbmRleCI6MTR9LCJnZW9tZXRyeSI6eyJ0eXBlIjoiTGluZVN0cmluZyIsImNvb3JkaW5hdGVzIjpbWzc0LjYzOTEyMiw0Mi44MzQzNzRdLFs3NC42NDUzODgsNDIuODEyNzE4XSxbNzQuNjQ4NDk1LDQyLjgwMzM5OV1dfSwiaWQiOjUwMDF9LHsidHlwZSI6IkZlYXR1cmUiLCJwcm9wZXJ0aWVzIjp7ImRlc2NyaXB0aW9uIjoiIiwic3Ryb2tlQ29sb3IiOiIjMDAwZmZmIiwic3Ryb2tlV2lkdGgiOjMsInN0cm9rZU9wYWNpdHkiOjEsInpJbmRleCI6MTV9LCJnZW9tZXRyeSI6eyJ0eXBlIjoiTGluZVN0cmluZyIsImNvb3JkaW5hdGVzIjpbWzc0LjY0ODQ3OCw0Mi44MDMyMV0sWzc0LjY0NTIxNiw0Mi44MDA5NDNdLFs3NC42NDIzODQsNDIuODAxMzg0XSxbNzQuNjQxNjk3LDQyLjgwMjEzOV0sWzc0LjYyOTMzNyw0Mi44MDQ2NThdLFs3NC42MjYxNjIsNDIuODAzOTY2XSxbNzQuNjIzNjcyLDQyLjgwNDQ2OV0sWzc0LjYxMjY4Niw0Mi44MDY4NjJdLFs3NC42MDk4NTQsNDIuODA1ODU1XSxbNzQuNTg4NDgyLDQyLjgwMzQ2Ml1dfSwiaWQiOjUwNTN9LHsidHlwZSI6IkZlYXR1cmUiLCJwcm9wZXJ0aWVzIjp7InRpdGxlIjoiUjJ4dlltRnNSWGh3Y21WemN3PT0iLCJkZXNjcmlwdGlvbiI6IiIsImNvbG9yIjoiIzAyODFmMiIsInpJbmRleCI6MTAwMDAwMDAwMH0sImdlb21ldHJ5Ijp7InR5cGUiOiJQb2ludCIsImNvb3JkaW5hdGVzIjpbNzQuNjEwMzUyLDQyLjg1MzczM119LCJpZCI6Njk3Nn1dLCJtYXBQb3NpdGlvbiI6eyJsYXQiOjQyLjg0NDAwMzA1MzczNzM2LCJsb24iOjc0LjU5ODc5ODc1MTgzMTA3LCJ6b29tIjoxM30sImlzV2hlZWxab29tRW5hYmxlZCI6dHJ1ZX0nKTwvc2NyaXB0PjxzY3JpcHQgYXN5bmM9IiIgdHlwZT0idGV4dC9qYXZhc2NyaXB0IiBzcmM9Imh0dHBzOi8vd3d3Lmdvb2dsZXRhZ21hbmFnZXIuY29tL2d0YWcvanM/aWQ9VUEtMTU4ODY2MTY4LTEiPjwvc2NyaXB0PjxzY3JpcHQgdHlwZT0idGV4dC9qYXZhc2NyaXB0Ij4oZnVuY3Rpb24oZSl7ZnVuY3Rpb24gdCgpe2RhdGFMYXllci5wdXNoKGFyZ3VtZW50cyl9d2luZG93LmRhdGFMYXllcj13aW5kb3cuZGF0YUxheWVyfHxbXSx0KCJqcyIsbmV3IERhdGUpLHQoImNvbmZpZyIsZSksd2luZG93Lmd0YWc9dH0pKCdVQS0xNTg4NjYxNjgtMScpPC9zY3JpcHQ+PC9ib2R5Pg=="
        )
      );
      frame.contentWindow.document.close();
    }
  }, []);

  return (
    <>
      <div className="pb-[50px]">
        <h1 className="arrangeDelivery__title">
          {t("button.arrange_delivery")}
        </h1>

        <ul className="text-[16px] mt-[20px] italic">
          <li>
            1. С момента оформления, доставка производится в течение 2 дней в порядке очередности по маршрутному листу. {" "}
          </li>
          <li>
            2. В день получения посылки вам позвонит менеджер с уточнением адреса доставки. {" "}
          </li>
          <li>
            3. Курьер с вами свяжется за 15-30 минут до приезда в пункт назначения. Время ожидания курьера не более 10-15 минут. <br/>
            В случае, если курьер не смог дозвониться до вас, то доставка не производится и ваша посылка возвращается в офис. После вы сможете только самостоятельно забрать посылку из нашего офиса.
          </li>
          <li>4. Подъем посылки до двери не осуществляется. Просим вас встретить посылку в пункте назначения. </li>
          <li>5. Общий вес посылки должен составлять от 0,5 до 15 кг. и размером не более 40х40х40.</li>
          <li>6. Курьер не сможет выдать вам посылку, в случае, если оплата не была произведена.</li>
        </ul>
      </div>

      <h1 className="text-[30px] text-black font-[400] mb-[20px]">
        {t("arrange_delivery.orders")}
      </h1>

      <div style={{ width: "100%", marginBottom: "50px" }}>
        <DataGrid
          rows={table.rows}
          columns={table.columns}
          keepNonExistentRowsSelected
          disableColumnFilter
          filterMode="server"
          loading={tableList.loading}
          localeText={{
            noRowsLabel: "Нет информации",
          }}
          autoHeight
          components={{
            Footer: () => {
              return (
                <GridFooterContainer>
                  <Pagination
                    count={table.filter.total_pages}
                    page={table.filter.page}
                    onChange={(event, value: number) => {
                      setTable((prevState: any) => ({
                        ...prevState,
                        filter: {
                          ...prevState.filter,
                          page: value,
                        },
                      }));
                    }}
                  />
                </GridFooterContainer>
              );
            },
          }}
        />
      </div>

      <Modal
        open={modal.open}
        onClose={() => setModal(modalInitialValues)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form
          onSubmit={handleFormSubmit}
          className="mainModal relative flex flex-col justify-start items-center"
        >
          <IconButton
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
            }}
            onClick={() => setModal(modalInitialValues)}
          >
            <CloseIcon />
          </IconButton>
          <h2 className="text-[30px] font-[600] text-[#1E1C2A] mb-[40px]">
            Оформление доставки
          </h2>

          <div className="w-full flex flex-col gap-[20px]">
            <Autocomplete
              freeSolo
              options={
                addresses.loading
                  ? []
                  : addresses.result?.data.map((option: any) => option.address)
              }
              value={modal.values.address}
              onChange={(event: any, newValue: string | null) => {
                setModal({
                  ...modal,
                  values: {
                    ...modal.values,
                    address: newValue !== null ? newValue : "",
                  },
                });
              }}
              inputValue={modal.values.address}
              onInputChange={(event, newInputValue) => {
                setModal({
                  ...modal,
                  values: {
                    ...modal.values,
                    address: newInputValue !== null ? newInputValue : "",
                  },
                });
              }}
              id="controllable-states-demo"
              loading={addresses.loading}
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  label={t("arrange_delivery.address")}
                />
              )}
            />
            <Autocomplete
              freeSolo
              options={
                phones.loading
                  ? []
                  : phones.result?.data.map((option: any) => option.phone)
              }
              value={modal.values.phone}
              onChange={(event: any, newValue: string | null) => {
                setModal({
                  ...modal,
                  values: {
                    ...modal.values,
                    phone: newValue !== null ? newValue : "",
                  },
                });
              }}
              inputValue={modal.values.phone}
              onInputChange={(event, newInputValue) => {
                setModal({
                  ...modal,
                  values: {
                    ...modal.values,
                    phone: newInputValue !== null ? newInputValue : "",
                  },
                });
              }}
              loading={phones.loading}
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  label={t("arrange_delivery.phone")}
                />
              )}
            />
            <FormControl fullWidth required>
              <InputLabel>{t("arrange_delivery.payment_type")}</InputLabel>
              <Select
                value={modal.values.payment}
                label={t("arrange_delivery.payment_type")}
                onChange={(event) => {
                  setModal({
                    ...modal,
                    values: {
                      ...modal.values,
                      payment: event.target.value,
                    },
                  });
                }}
              >
                {payments.loading ? (
                  <div>loading</div>
                ) : payments.error ? (
                  <div>Error</div>
                ) : (
                  payments.result?.data.map((item: any) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.payment}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </div>

          <div className="flex justify-between gap-[40px] items-center mt-[20px]">
            <Button
              type="button"
              variant="outlined"
              onClick={() => {
                setModal(modalInitialValues);
              }}
            >
              Отмена
            </Button>
            <LoadingButton
              type="submit"
              disabled={modal.requested}
              loading={modal.requested}
              variant="contained"
            >
              Готово
            </LoadingButton>
          </div>
        </form>
      </Modal>

      <div className="w-full mt-[100px]">
        <h1 className="arrangeDelivery__title">
          {t("arrange_delivery.shippingArea")}
        </h1>

        <iframe id="map_376303947" width="100%" height="600px" sandbox="allow-modals allow-forms allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation"></iframe>
      </div>
    </>
  );
}
